module.exports = __webpack_public_path__ + "static/media/ic_p5off.702be3dd.png";